(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/single-rows/single-board.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/single-rows/single-board.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.SingleBoard = Backbone.Model.extend({
    log: new svs.core.log.Logger('svs.tipset.models.SingleBoard'),
    defaults: {
      boardData: [],
      boardId: 0,
      isActiveBoard: true,
      isOpenDraw: false,
      baseRow: []
    },
    initialize: function() {
      this.set({
        isCompleteBoard: this.isCompleteBoard(),
        hasMarkedItems: this.hasMarkedItems(),
        isOpenDraw: this.isEnabled()
      });
    },

    update: function() {
      this.set({
        isCompleteBoard: this.isCompleteBoard(),
        hasMarkedItems: this.hasMarkedItems(),
        isActiveBoard: this.hasMarkedItems()
      });
      this.trigger('change', this);
    },
    isEnabled: function() {
      return (
        svs.tipset.collections.draws &&
        svs.tipset.collections.draws.getCurrentDraw() &&
        svs.tipset.collections.draws.isCurrentDrawOpen()
      );
    },
    isCompleteBoard: function() {
      for (var i = 0; i < this.get('boardData').length; i++) {
        if (this.get('boardData')[i] === 0) {
          return false;
        }
      }
      return true;
    },
    hasMarkedItems: function() {
      for (var i = 0; i < this.get('boardData').length; i++) {
        if (this.get('boardData')[i] !== 0) {
          return true;
        }
      }
      return false;
    },

    setBoardData: function(matchnr, mark) {
      mark = this.get('boardData')[matchnr] == mark ? 0 : mark;
      this.get('boardData')[matchnr] = mark;
      this.get('baseRow')[matchnr] = mark;
      this.update();
      this.trigger('boardDataChanged');
    },

    clearBoardData: function(options) {
      var isSilent = options && options.isSilent ? options.isSilent : false;

      this.set(
        'boardData',
        _.map(this.get('boardData'), function() {
          return 0;
        }),
        { silent: true }
      );
      this.clearBaseRow();
      this.update();

      if (!isSilent) {
        this.trigger('boardDataChanged');
      }
    },

    setCompleteBoardData: function(boardData, removeBaseRow) {
      this.set(
        {
          isActiveBoard: true,
          boardData: boardData
        },
        { silent: true }
      );
      if (removeBaseRow) {
        this.clearBaseRow();
      }
      this.update();
      this.trigger('boardDataChanged');
    },
    getHasMarksSetByUser: function() {
      var nrOfMarksSetByUser = 0;
      for (var i = 0; i < this.get('baseRow').length; i++) {
        if (this.get('baseRow')[i] !== 0) {
          nrOfMarksSetByUser++;
        }
      }
      return nrOfMarksSetByUser > 0;
    },

    removeXpertMarks: function() {
      this.set('boardData', this.get('baseRow'), { silent: true });
    },

    clearBaseRow: function() {
      this.set(
        'baseRow',
        _.map(this.get('baseRow'), function() {
          return 0;
        }),
        { silent: true }
      );
    }
  });
})(Backbone, _, svs);

 })(window);